import { ComparisonSpec } from './ComparisonSpec';

export interface NoComparisonSpec extends ComparisonSpec {
  readonly type: 'NO_COMPARISON';
}

/**
 * @param message The message to display when presented as an option in the
 * adjust and compare screen. Defaults to the empty string.
 */
export const makeNoComparisonSpec = (message: string = ''): NoComparisonSpec => {
  return {
    type: 'NO_COMPARISON',
    message,
  };
};
